import "./Contact.module.css";
import Header from "@/reusable_sections/Header";
import EventDetailsForm from "./sections/EventDetailsForm";
import AdditionalContactInformation from "./sections/AdditionalContactInformation";
import PizzaGallery from "./sections/PizzaGallery";
import Contact from "./sections/Contact";
import ContactForm from "./sections/ContactForm";
import PremiumContactDetails from "./sections/PremiumContactDetails";
import BookingInquirySection from "./sections/BookingInquirySection";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Header />
      <EventDetailsForm />
      <PizzaGallery />
      <AdditionalContactInformation />
      <Contact />
      <ContactForm />
      <BookingInquirySection />
      <PremiumContactDetails />
      <Footer />
    </div>;
}